import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { ReactNode } from 'react';

interface IModalDialogProps {
  showDialog: boolean;
  heading: string;
  message: string | ReactNode;
  okCallback?: () => void;
  okButtonText: string | null;
  cancelCallback?: () => void;
  cancelButtonText?: string | null;
}

export const ModalDialog = ({
  showDialog,
  heading,
  message,
  okCallback = undefined,
  okButtonText = null,
  cancelCallback = undefined,
  cancelButtonText = null
}: IModalDialogProps) => {
  return (
    <>
      <Modal show={showDialog} backdrop="static" keyboard={false} centered={true}>
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">{message}</div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          {typeof cancelCallback === 'function' && (
            <div>
              <button className="btn btn-danger" onClick={cancelCallback}>
                {cancelButtonText ?? 'Cancel'}
              </button>
            </div>
          )}
          {typeof okCallback === 'function' && (
            <div>
              <button className="btn btn-success" onClick={okCallback}>
                {okButtonText ?? 'Ok'}
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

ModalDialog.propTypes = {
  showDialog: PropTypes.bool,
  heading: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  okCallback: PropTypes.func,
  okButtonText: PropTypes.string,
  cancelCallback: PropTypes.func,
  cancelButtonText: PropTypes.string
};

export default ModalDialog;
